<template>
  <div class="pa2">
    <div
      v-if="notes.length"
      class="b mt1">Notes</div>
    <div
      v-for="(note, index) in notes"
      :key="'note' + index"
      class="pl3"
    >{{ note.ft }}</div>

    <div
      v-if="definitions.length"
      class="b mt1">Measure Definitions</div>
    <div
      v-for="(def, index) in definitions"
      :key="'def' + index"
      class="pl3"
    >
      {{ def.ft }}
    </div>

    <div class="b mt1">Suggested Citation</div>
    <div class="pl3">{{ citation.ft }} [accessed {{ today }}]. URL:
      <a
        :href="citation.url | convertRelativeUrlToWCMSUrl"
        target="_blank">{{ citation.url | convertRelativeUrlToWCMSUrl }}</a>
    </div>

    <div
      v-if="!printerFriendly"
      class="rldiv">
      <div class="rlheader">Related Links</div>
      <ul class="ma0 pv2 cf">
        <li
          v-for="(link, index) in relatedLinks"
          :key="'rl' + index"
          class="fl w-third"
        >
          <a
            :href="link.url | convertRelativeUrlToWCMSUrl"
            target="_blank">{{ link.ft }}</a>
        </li>
      </ul>
    </div>

  </div>
</template>


<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import helper from '../../helper';

export default {
  filters: {
    convertRelativeUrlToWCMSUrl: helper.convertRelativeUrlToWCMSUrl,
  },
  computed: {
    ...mapState({
      footnotes: state => state.footnotes,
    }),
    notes() {
      return _(this.footnotes).filter({ type: 'GlobalNote' }).orderBy('sort', 'asc').value();
    },
    definitions() {
      return _(this.footnotes).filter({ type: 'MeasureDefinitions' }).orderBy('sort', 'asc').value();
    },
    citation() {
      return _(this.footnotes).find({ type: 'SuggestedCitation' });
    },
    today() {
      return moment().format('MMM D, YYYY');
    },
    relatedLinks() {
      return _(this.footnotes).filter(x => x.type === 'RelatedLinks').orderBy('sort', 'asc').value();
    },
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
  },
};
</script>

<style scoped>
  .b {
    font-weight: bold;
  }

  .mt1 {
    margin-top: .25rem;
  }


  .rldiv {
    border: 1px solid #C0C0C0;
    margin: 5px 0;
  }

  .rldiv::after {
    content: " ";
    display: block;
    height: 0;
    clear: both;
  }

  .rlheader {
    padding: .25rem;
    font-weight: bold;
    background-color: lightgray;
    border-bottom: 1px solid #C0C0C0;
  }

  .pa2 {
    padding: .5rem;
  }

  .pv2 {
    padding-top: .5rem;
    padding-bottom: .5rem;
  }

  .pl3 {
    padding-left: 1rem;
  }

  .ma0 {
    margin: 0;
  }

  .w-third {
    width: 33.33333%;
  }

  .fl,
  .fr {
    _display: inline;
  }

  .fl {
    float: left;
  }

  .cf:before,
  .cf:after {
    content: " ";
    display: table;
  }

  .cf:after {
    clear: both;
  }

  .cf {
    *zoom: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PageFootnotes.vue